import React from 'react';

import { withStyles } from '@material-ui/core/styles';
import { useState } from 'react';

import Checkbox from '@material-ui/core/Checkbox';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';

import DropdownMenu from 'ui/DropdownMenu';
import { Android, Apple, Windows } from 'ui/OsIcons';
import ConfirmationDialog from 'ui/dialog/ConfirmationDialog';
import formatters from '../../../../formatters';

const styles = theme => ({
    container: {
        display: 'flex',
        flexWrap: 'wrap',
        width: '100%',
    },
});

const DevicesTab = props => {
    const { classes, onChange, mode, devices = [] } = props;
    const [selected, setSelected] = useState({});
    const [showConfirmation, setShowConfirmation] = useState(false);
    const actions = [
        {
            key: 'delete',
            name: 'Delete devices',
            onClick: dropdownCloseCallback => {
                dropdownCloseCallback();
                setShowConfirmation(true);
            },
        },
    ];

    const handleToggelSelected = device => () => {
        if (selected[device.uuid]) {
            delete selected[device.uuid];
            setSelected({ ...selected });
        } else {
            setSelected({ ...selected, ...{ [device.uuid]: device.nickname } });
        }
    };

    const renderOsIcon = value => {
        if (value.toLowerCase().startsWith('win')) {
            return <Windows />;
        }

        if (
            value.toLowerCase().startsWith('ios') ||
            value.toLowerCase().startsWith('mac')
        ) {
            return <Apple />;
        }

        if (value.toLowerCase().startsWith('android')) {
            return <Android />;
        }
    };
    return (
        <div className={classes.container}>
            <ConfirmationDialog
                open={showConfirmation}
                title="Delete devices"
                subtitle1="Are you sure you want to delete:"
                data={Object.values(selected)}
                onCancel={() => setShowConfirmation(false)}
                onOk={() => {
                    setShowConfirmation(false);
                    onChange(Object.keys(selected));
                }}
            />
            <DropdownMenu
                name="Actions"
                menuItems={actions}
                disabled={Object.keys(selected).length === 0}
            />
            <Table>
                <TableHead>
                    <TableRow>
                        <TableCell padding="checkbox" />
                        <TableCell style={{ width: '67%' }}>Name</TableCell>
                        <TableCell style={{ width: '10%' }}>Type</TableCell>
                        <TableCell style={{ minWidth: 170 }}>
                            Last Backup
                        </TableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                    {devices.map(device => {
                        return (
                            <TableRow key={device.uuid}>
                                <TableCell padding="checkbox">
                                    <Checkbox
                                        disabled={mode === 'details'}
                                        checked={Boolean(selected[device.uuid])}
                                        onChange={handleToggelSelected(device)}
                                    />
                                </TableCell>
                                <TableCell align="left">
                                    {device.nickname}
                                </TableCell>
                                <TableCell align="left">
                                    {renderOsIcon(
                                        device.installation__os__name
                                    )}
                                </TableCell>
                                <TableCell align="left">
                                    {formatters.date(device.last_sync_date)}
                                </TableCell>
                            </TableRow>
                        );
                    })}
                </TableBody>
            </Table>
        </div>
    );
};

export default withStyles(styles)(DevicesTab);
